import BaseModule from './BaseModule.js';

class BankPixCashIns extends BaseModule {
  async paginate({ page, per_page, init_date, end_date, status, provider }) {
    return await this.get(`back-office/bank_pix_cash_ins`, {
      params: { page, per_page, init_date, end_date, status, provider },
    });
  }

  async fetch({ id, provider }) {
    return await this.post(`back-office/bank_pix_cash_ins`, { id, provider });
  }

  async refund(pix) {
    return await this.put(`/back-office/bank_pix_cash_ins/${pix.id}/refund`);
  }
}

export default BankPixCashIns;
